<template>
  <generic-modal
    v-if="showModal"
    @close="closeModalM()"
    :height="menuModalDim.height"
    :width="menuModalDim.width"
    :modalClass="menuModalDim.modalClass"
    :bottom="menuModalDim.bottom"
    :padding="menuModalDim.padding"
    :genericModalSource="'bottomBarMenu'"
  >
    <template v-slot:header>
      <div></div>
    </template>
    <template v-slot:body>
      <div class="menu-pop-content">
        <ul
          class=""
          v-for="(item, index) in getCategoryNameAndCountForBottomBar"
          v-bind:key="item.categoryName"
        >
          <li
            class="mb9 cursor-pointer"
            :class="{
              // disabled: getCategoryNameAndCountForBottomBar[index].count == 0,
              bgGrey: selectedMenuItem == item.nodeId,
            }"
            @click="goto(item)"
            v-if="
              item.visible &&
              getCategoryNameAndCountForBottomBar[index].count != 0
            "
          >
            <div class="d-flex justify-content-between plr16">
              <div
                class="fs-14"
                :class="{
                  highlightText: selectedMenuItem == item.nodeId,
                }"
              >
                {{ item.categoryName }}
              </div>
              <div class="fs-14">{{ item.count }}</div>
            </div>
          </li>
        </ul>
      </div>
    </template>
  </generic-modal>
</template>
<script>
import GenericModal from "./GenericModal.vue";
import { keyMapsGetter, keyMapsMutation } from "../helpers/storeKeys";
import Utility from "../helpers/utility";
import {
  imgBaseUrl,
  staticImgBaseUrl,
  projectBasePathWithFolder,
} from "../config/apiEndpoints";
import localStorageFunc from "../helpers/localStorageFunc";
import { EVENT_CLICK_CATEGORY_BOTTOM_STICKY_MENU } from "../helpers/analyticsEvents";

export default {
  name: "BottomBarMenuModal",
  components: {
    GenericModal,
  },
  props: ["showModal"],
  data() {
    return {
      menuModalDim: {
        width: "255px",
        height: "fit-content",
        bottom: "20px",
        modalClass: "menu-modal",
        padding: "0px !important",
      },
      staticImgBaseUrl: staticImgBaseUrl,
      imgBaseUrl: imgBaseUrl,
    };
  },
  mounted() {
    window.addEventListener("scroll", () => {
      this.watchSelectedMenuItem();
    });
  },
  destroyed() {
    window.removeEventListener("scroll", this.watchSelectedMenuItem);
  },
  methods: {
    watchSelectedMenuItem() {
      if (
        window.pageYOffset < 50 &&
        !this.selectedMenuItem?.startsWith("undefined")
      ) {
        this.$store.commit(
          keyMapsMutation.UPDATE_SELECTED_MENU_ITEM,
          "undefined"
        );
      }
    },
    closeModalM(crossClicked = false) {
      document.body.classList.remove("body-stop-scroll-mobile");
      this.$emit("close-menu-modal");
    },
    // goto({ index, nodeId, categoryName, count }) {
    //   if (!count) return;
    //   this.$store.commit(keyMapsMutation.UPDATE_SELECTED_MENU_ITEM, nodeId);
    //   Utility.gotoElement({ id: nodeId });
    //   this.closeModalM();
    //   EVENT_CLICK_CATEGORY_BOTTOM_STICKY_MENU({ subCategory: categoryName });
    // },
    scrollToCategoryId(item, url) {
      if (item) {
        const categoryId = item?.nodeId || "menuTop";
        url = Utility.addUpdateParam(url, "showSearchModal", false);
        return Utility.addUpdateParam(url, "scrollTo", categoryId);
      }
      return url;
    },
    goto(item) {
      this.closeModalM();
      EVENT_CLICK_CATEGORY_BOTTOM_STICKY_MENU({ subCategory: item.nodeName });
      let url =
        projectBasePathWithFolder +
        "/menu/" +
        localStorageFunc.storeId() +
        Utility.getUrlQueryString();
      url = this.scrollToCategoryId(item, url);
      window.location.href = url;
    },
  },
  computed: {
    getCategoryNameAndCountForBottomBar() {
      let productItems =
        this.$store.getters[
          keyMapsGetter.GET_CATEGORY_NAME_AND_COUNT_FOR_BOTTOM_BAR
        ];
      return productItems;
    },
    selectedMenuItem() {
      return this.$store.state.Menu.selectedMenuItem;
    },
  },
};
</script>
